import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Drawer, Button, Space, notification } from "antd";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faEdit, faEllipsis, faCloudDownload, faCloudArrowUp, faRightToBracket, faRightFromBracket, faMapMarked, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';

import TobNavBar from "../../DashBaord/Top_navbar";

import { Link, useNavigate, useLocation } from "react-router-dom";

import {
  addNotes,
  attendanceList,
  attendanceLocationList,
  attendanceSummery,
  attendanceSummeryAgent
} from "../../../controllers/V1/customerDue/dueController";
import ExportPopup from '../customer_due/Export';
import { usePermissions } from "../../../controllers/PermissionContext";
import UserSelectWithSearch from "../../../components/UserSelectWithSearch";
import SkeltonList from "../../../components/SkeltonEffect/list";
import CalendarSkeleton from "../../../components/SkeltonEffect/CalendarSkeleton";
import Pagination from "@mui/material/Pagination";
import {getPage} from "../../../controllers/common";
import * as XLSX from 'xlsx';
import { list as userList } from "../../../controllers/V1/customerDue/dueController";
import { list as agentList } from "../../../controllers/V1/salesAgentControllers";
import AgentSelectWithSearch from "../../../components/AgentSelectWithSearch";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Setup the localizer for react-big-calendar
const localizer = momentLocalizer(moment);

export default function BasicTabs() {
  const location = useLocation();
  const PERMISSION = usePermissions("customer_due");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFilterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [isDetailShow, setDetailShow] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [isLocationTable, setLocationTable] = useState(false);
  const toggleLocationTable = () => {
    setLocationTable(!isLocationTable);
    if(!isLocationTable){
      setLocationList([]);
      handleViewAllLocations();
    }
  }

  const handleDetailDrawer = () => {
    setLocationList([]);
    setDetailShow(!isDetailShow);
    if(isDetailShow && isLocationTable){
      toggleLocationTable();
    }
  };
  
  const [checkOutNotes, setCheckoutNotes] = useState('');
  const [checkInNotes, setCheckinNotes] = useState('');
  const [currentUserId, setCurrentUserId] = useState(location?.state?._id || '');
  // Handle event selection
  const handleSelectEvent = (event) => {
    
    // Find both check-in and check-out for the same date
    const eventDate = moment(event.start).format('YYYY-MM-DD');
    const dayEvents = attendanceData.filter(e => 
      moment(e.start).format('YYYY-MM-DD') === eventDate
    );
    setSelectedEvent(dayEvents);
    setDetailShow(true);
  };

  // Handle month navigation
  const handleNavigate = (date) => {    
    setCurrentMonth(date);
    getList(date);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [attendanceData, setAttendanceData] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End
  const [currentUserType, setCurrentUserType] = useState('Users');



  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async (date = new Date()) => {
    try {
      if(!currentUserId){
        return false;
      }
      setIsLoading(true);
      setAttendanceData([]);
      const firstDate = moment(date).startOf('month').format('YYYY-MM-DD');
      const lastDate = moment(date).endOf('month').format('YYYY-MM-DD');
      const options = {
        type: "",
        condition: {
          ...(currentUserType === 'Users' ? { users_id: currentUserId } : { agent_id: currentUserId }),
          // users_id: currentUserId,
          type: {$in : ["check_in","check_out"]},
          createdAt: { $gte: firstDate, $lte: lastDate }
        },
        select: {},
        sort: { createdAt : -1 },
        skip: 0,
        limit: 0,
      };
      const listData = await attendanceList(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setAttendanceData(transformDataToEventFormat(listData?.result));
        }
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  }; //End
  // const transform data to event format
  const transformDataToEventFormat = (data) => {
    return data.map(item => (
      {
      id: item._id,
      title: `${item.type === "check_in" ? "🟢 In" : "🔴 Out"} ${moment(item.date_time).format('hh:mm A')}`,
      start: new Date(item.date_time),
      end: new Date(item.date_time),
      notes: item.notes,
      type: item.type,
      latitude: item.latitude,
      longitude: item.longitude
    }
  ));
  }

  // Handle track location button click
  const handleTrackLocation = (event) => {
    if (event.latitude && event.longitude) {
      const lat = event.latitude;
      const lng = event.longitude;
      
      const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(mapUrl, "_blank");
      
    } else {
      alert('Location data not available for this attendance record.');
    }
  };
  const [locationList, setLocationList] = useState([]);
  // Handle view all locations for the day
  const handleViewAllLocations = async () => {
    try {
      setIsLoading(true);
      const firstDate = moment(currentMonth).startOf('month').format('YYYY-MM-DD');
      const lastDate = moment(currentMonth).endOf('month').format('YYYY-MM-DD');
      const options = {
        type : "",
        condition : {
          ...(currentUserType === 'Users' ? { users_id: currentUserId } : { agent_id: currentUserId }),
          createdAt: { $gte: firstDate, $lte: lastDate },
          status : "A"
        },
        select : {},
        sort : { createdAt : -1 },
        skip : SKIP,
        limit : LIMIT,
      }
      const res = await attendanceLocationList(options);
      if(res.status === true){
        setLocationList(res?.result);
        setTotalPages(getPage(res?.count))
        setTotalDataCount(res?.count|| 0);
      }else{
        setLocationList([]);
        setTotalPages(getPage(1))
      }

    } catch (error) {
      setIsLoading(false);
      setLocationList([]);
      setTotalPages(getPage(1))
    } finally {
      setIsLoading(false);
    }
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      handleFilterDrawer();
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "U-Winn CRM || Attendance list";
  }, [currentUserId]);

  useEffect(()=>{
    handleViewAllLocations();
  },[SKIP, currentUserId])
  
  const handleNotesChange = (e) => {
    try {
      const {name, value} = e.target;
      if(name === 'check_out_notes'){
        setCheckoutNotes(value);
      }else if(name === 'check_in_notes'){
        setCheckinNotes(value);
      }
    } catch (error) {
      
    }
  }
  const handleSaveNotes = async (event) => {
    const options = {
      id : event?.id,
      notes : event?.type === 'check_in' ? checkInNotes : checkOutNotes,
    }
    const res = await addNotes(options);
    if(res.status === true){
      alert("Notes saved successfully");
    }else{
      alert(res.message);
    }
  }
  const handleUserChange = (value) => {
    try {
      setCurrentUserId(value);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const getUserInfo = async () => {
    try {
      const options = {
        type : "single",
        condition : { _id : currentUserId },
        select : { users_name : 1, last_name : 1, users_type : 1 },
      }
      const USERDATA = await userList(options);
      if(USERDATA.status === true){
        return USERDATA?.result || {};
      }
    } catch (error) {
      return {};
    }
  }

  const getAgentInfo = async () => {
    try {
      const options = {
        type : "single",
        condition : { _id : currentUserId },
        select : { first_name : 1, last_name : 1 },
      }
      const AGENTDATA = await agentList(options);
      if(AGENTDATA.status === true){
        return AGENTDATA?.result || {};
      }
    } catch (error) {
      return {};
    }
  }

  const exportToExcel = async () => {
    try {
      // Get user information
      if(!currentUserId) return false;
      let userInfo = {};
      let userName = "";
      let userType = "";
      if(currentUserType === 'Users'){
        userInfo = await getUserInfo();
        userName = userInfo?.users_name ? `${userInfo?.users_name} ${userInfo?.last_name || ''}`.trim() : '';
        userType = userInfo?.users_type || '';
      } 
      if(currentUserType === 'Agent'){
        userInfo = await getAgentInfo();
        userName = userInfo?.first_name ? `${userInfo?.first_name} ${userInfo?.last_name || ''}`.trim() : '';
        userType = 'Field Officer' || '';
      }

      if(!userName || !userType){
        notification.open({
          message: "Oops!",
          description: "Something went wrong while exporting the data.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
        return false;
      }
      
      
      // Get date range from current month
      const firstDate = moment(currentMonth).startOf('month');
      const lastDate = moment(currentMonth).endOf('month');

      // Group attendance data by date
      const groupedData = {};
      if(attendanceData && attendanceData?.length > 0){
        attendanceData.forEach(item => {
          const dateKey = moment(item.start).format('YYYY-MM-DD');
          if (!groupedData[dateKey]) {
            groupedData[dateKey] = {
              date: dateKey,
              checkIn: null,
              checkOut: null
            };
          }
          if (item.type === 'check_in') {
            groupedData[dateKey].checkIn = item;
          } else if (item.type === 'check_out') {
            groupedData[dateKey].checkOut = item;
          }
        });
      }

      // Generate all dates in the month
      const allDatesInMonth = [];
      let currentDate = firstDate.clone();
      
      while (currentDate.isSameOrBefore(lastDate, 'day')) {
        allDatesInMonth.push(currentDate.format('YYYY-MM-DD'));
        currentDate.add(1, 'day');
      }

      // Transform data to include all dates in the month
      const modifiedData = allDatesInMonth.map((dateKey, index) => {
        const dayData = groupedData[dateKey];
        const checkIn = dayData?.checkIn;
        const checkOut = dayData?.checkOut;
        
        // Calculate worked hours and status
        let workedHours = '';
        let attendanceStatus = '';
        
        if (checkIn && checkOut) {
          const duration = moment.duration(moment(checkOut.start).diff(moment(checkIn.start)));
          const hours = Math.floor(duration.asHours());
          const minutes = duration.minutes();
          workedHours = `${hours}h ${minutes}m`;
          attendanceStatus = 'Present';
        } else if (checkIn && !checkOut) {
          workedHours = 'N/A';
          attendanceStatus = 'Check-out Missing';
        } else if (!checkIn && checkOut) {
          workedHours = 'N/A';
          attendanceStatus = 'Check-in Missing';
        } else {
          // No attendance data for this date
          workedHours = '';
          attendanceStatus = 'Absent';
        }

        return {
          "Sl No": index + 1,
          "Date": dateKey,
          "Check-in Time": checkIn ? moment(checkIn.start).format('HH:mm:ss') : '',
          "Check-in Location": checkIn && checkIn.latitude && checkIn.longitude 
            ? `https://www.google.com/maps?q=${checkIn.latitude},${checkIn.longitude}` 
            : '',
          "Check-out Time": checkOut ? moment(checkOut.start).format('HH:mm:ss') : '',
          "Check-out Location": checkOut && checkOut.latitude && checkOut.longitude 
            ? `https://www.google.com/maps?q=${checkOut.latitude},${checkOut.longitude}` 
            : '',
          "Worked Hours": workedHours,
          "Attendance Status": attendanceStatus
        };
      });

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      
      // Create header rows
      const headerData = [
        { A: "User Name", B: userName },
        { A: "User Type", B: userType },
        { A: "From Date", B: firstDate.format('YYYY-MM-DD') },
        { A: "To Date", B: lastDate.format('YYYY-MM-DD') },
        {}, // Empty row
      ];

      // Convert to worksheet
      const worksheet = XLSX.utils.json_to_sheet(headerData, { 
        skipHeader: true 
      });

      // Append the attendance data
      XLSX.utils.sheet_add_json(worksheet, modifiedData, { 
        origin: 'A6', 
        skipHeader: false 
      });

      // Set column widths
      worksheet['!cols'] = [
        { wch: 8 },   // Sl No
        { wch: 12 },  // Date
        { wch: 15 },  // Check-in Time
        { wch: 50 },  // Check-in Location
        { wch: 15 },  // Check-out Time
        { wch: 50 },  // Check-out Location
        { wch: 15 },  // Worked Hours
        { wch: 20 }   // Attendance Status
      ];

      XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance list");
      XLSX.writeFile(workbook, `Attendance-List-${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      console.error('Export error:', error);
      notification.open({
        message: "Oops!",
        description: "Something went wrong while exporting the data.",
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
    } finally {
      setIsLoading(false);
    }

  };

  const exportSummeryToExcel = async () => {
    try {
      setIsLoading(true);
      
      // Call the attendance summary API
      const options = {
        date: currentMonth
      };
      let res = {};
      if(currentUserType === 'Users'){
        res = await attendanceSummery(options);
      }
      if(currentUserType === 'Agent'){
        res = await attendanceSummeryAgent(options);
      }
      
      if (res.status === false || !res.result || res.result.length === 0) {
        notification.open({
          message: "Oops!",
          description: res.message || "No attendance summary data found.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
        return false;
      }

      // Transform data for Excel
      const summaryData = res.result.map((item, index) => ({
        "Sl No": index + 1,
        "User Name": item["User Name"] || '',
        "User Type": item["User Type"] || '',
        "From Date": item["From Date"] || '',
        "To Date": item["To Date"] || '',
        "Total Working Days": parseInt(item["Total Working Days"]) || 0,
        "Present Days": parseInt(item["Present Days"]) || 0,
        "Absent Days": parseInt(item["Absent Days"]) || 0,
        "Leaves Days": parseInt(item["Leaves Days"]) || 0,
        "Weekly Offs": item["Weekly Offs"] || 0,
        "Total Worked Hours": item["Total Worked Hours"] || 0
      }));

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(summaryData);

      // Set column widths
      worksheet['!cols'] = [
        { wch: 8 },   // Sl No
        { wch: 25 },  // User Name
        { wch: 20 },  // User Type
        { wch: 15 },  // From Date
        { wch: 15 },  // To Date
        { wch: 20 },  // Total Working Days
        { wch: 15 },  // Present Days
        { wch: 15 },  // Absent Days
        { wch: 15 },  // Leaves Days
        { wch: 15 },  // Weekly Offs
        { wch: 20 }   // Total Worked Hours
      ];

      XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Summary");
      XLSX.writeFile(workbook, `${currentUserType === 'Users'? 'Users':"Field Officer"}-Attendance-Summary-${moment(currentMonth).format('YYYY-MM')}.xlsx`);

      notification.open({
        message: "Success!",
        description: "Attendance summary exported successfully.",
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "green" }} icon={faInfoCircle} />,
        duration: 2,
      });
    } catch (error) {
      console.error('Export error:', error);
      notification.open({
        message: "Oops!",
        description: "Something went wrong while exporting the summary.",
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
    } finally {
      setIsLoading(false);
    }
  }


  const handleUserTypeChange = (e) => {
    try {
      const {value} = e.target;
      setCurrentUserType(value);
    } catch (error) {
      
    }
  }
  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Attendance list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  {/* <button className="btn btn-dark" onClick={() => navigate("/customers-due/list")}>Back</button> */}
                  <select value={currentUserType} onChange={handleUserTypeChange} name="user_type" className="form-control store_input_field">
                    <option value="Users" selected={currentUserType === 'Users'}>Users</option>
                    <option value="Agent" selected={currentUserType === 'Agent'}>Field Office</option>
                  </select>
                  
                </div>
                {currentUserType === 'Users' ? (
                  <UserSelectWithSearch
                  value={currentUserId}
                  onChange={(value) => handleUserChange(value)}
                  placeholder="Search Manager, Sales Supervisor, Sales Person"
                  className="form-control store_input_field"
                  style={{ width: '100%' }}
                  disableOptions={false}
                  multiple={false}
                  showSelectAll={false}
                />
                ) : (
                  <AgentSelectWithSearch
                    value={currentUserId}
                    onChange={(value) => handleUserChange(value)}
                    placeholder="Search Field Office"
                    className="form-control store_input_field"
                    style={{ width: '100%' }}
                    disableOptions={false}
                    multiple={false}
                    showSelectAll={false}
                  />
                )}
                <div className="fa_filter_rating_review filter_img_and_add_btn_main"> 
                  <div className="inventory_filter_div" onClick={exportToExcel}>
                    <FontAwesomeIcon icon={faCloudDownload} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Export
                    </Link>
                  </div>
                  <div className="inventory_filter_div" onClick={exportSummeryToExcel}>
                    <FontAwesomeIcon icon={faCloudDownload} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Summery
                    </Link>
                  </div>
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      {/* Custom Big Calendar */}
                      <div style={{ height: '600px', padding: '20px' }}>
                        {isLoading ? (
                          <CalendarSkeleton />
                        ) : (
                          <Calendar
                            localizer={localizer}
                            events={attendanceData}
                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: '100%' }}
                            onSelectEvent={handleSelectEvent}
                            // onSelectSlot={handleSelectSlot}
                            onNavigate={handleNavigate}
                            date={currentMonth}
                            selectable
                            popup
                            views={['month']}
                            defaultView="month"
                            step={30}
                            showMultiDayTimes
                            eventPropGetter={(event) => ({
                              style: {
                                backgroundColor: event.type === 'check_in' ? '#28a745' : '#dc3545',
                                borderRadius: '5px',
                                opacity: 0.8,
                                color: 'white',
                                border: '0px',
                                display: 'block'
                              }
                            })}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      
      {/* Event Details Drawer */}
      <Drawer
        title="Attendance Details"
        placement="left"
        width={"100%"}
        onClose={handleDetailDrawer}
        open={isDetailShow}
        extra={
          <Space>
            <Button onClick={handleDetailDrawer}>Close</Button>
          </Space>
        }
      >
        {selectedEvent && selectedEvent.length > 0 && (
          <div className="responsive row">
            <div className="col-12 col-md-4">
              <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                <h6 className="mb-1 text-muted small">DATE</h6>
                <h5 className="mb-0">{moment(selectedEvent[0].start).format('MMMM DD, YYYY')}</h5>
                <p className="mb-0 text-muted">{moment(selectedEvent[0].start).format('dddd')}</p>
              </div>
            </div>
            <div className="col-12 col-md-4">
              {selectedEvent.length === 2 && (
                <div className="mt-0 p-3" style={{ backgroundColor: '#e7f3ff', borderRadius: '5px', borderLeft: '4px solid #007bff' }}>
                  <label className="text-muted small mb-3">Total Duration</label>
                  <h5 className="mb-0" style={{ color: '#007bff' }}>
                    {(() => {
                      const checkIn = selectedEvent.find(e => e.type === 'check_in');
                      const checkOut = selectedEvent.find(e => e.type === 'check_out');
                      if (checkIn && checkOut) {
                        const duration = moment.duration(moment(checkOut.start).diff(moment(checkIn.start)));
                        const hours = Math.floor(duration.asHours());
                        const minutes = duration.minutes();
                        return `${hours} hours ${minutes} minutes`;
                      }
                      return 'N/A';
                    })()}
                  </h5>
                </div>
              )}
            </div>
            <div className="col-12 col-md-4">
              <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                <h6 className="mb-1 text-muted small">TOTAL LOCATIONS</h6>
                <h5 className="mb-0">{totalDataCount || 0}</h5>
                <Link to={'javaScript:void(0)'} onClick={toggleLocationTable} style={{textDecoration: 'none', color: '#007bff'}} className=" mb-0 text-muted">📍 Location Tracking</Link>
              </div>
            </div>
            {(!isLocationTable) ? (
              <div className="row">
                {selectedEvent.map((event, index) => (
                  <div className="col-6 mb-3" key={event.id}>
                    <div className="card shadow-sm" style={{ 
                      borderLeft: `4px solid ${event.type === 'check_in' ? '#28a745' : '#dc3545'}` 
                    }}>
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="card-title mb-0">
                            <span style={{
                              padding: '5px 15px',
                              borderRadius: '5px',
                              backgroundColor: event.type === 'check_in' ? '#28a745' : '#dc3545',
                              color: 'white',
                              fontSize: '14px',
                              fontWeight: 'bold'
                            }}>
                              {event.type === 'check_in' ? '🟢 CHECK IN' : '🔴 CHECK OUT'}
                            </span>
                          </h5>
                        </div>
                        
                        <div className="mb-3">
                          <label className="text-muted small">Time</label>
                          <h4 className="mb-0 mt-1" style={{ color: event.type === 'check_in' ? '#28a745' : '#dc3545' }}>
                            {moment(event.start).format('h:mm:ss A')}
                          </h4>
                        </div>

                        {/* {event.notes && ( */}
                          <div className="mb-2">
                            <label className="text-muted small">{`${event.type === 'check_in' ? 'Check In' : 'Check Out'} Notes`}</label>
                            {/* <p className="mb-0">{event.notes}</p> */}
                            <textarea className="form-control" name={`${event.type}_notes`} onChange={handleNotesChange} placeholder={`Enter your ${event.type === 'check_in' ? 'check in' : 'check out'} notes`} rows={3} >{checkInNotes || event?.notes}</textarea>
                          </div>
                          <div className="d-flex gap-2">
                            <Button onClick={()=>handleSaveNotes(event)}>{`${event.notes ? "Update": "Save"}`} Notes</Button>
                            <Button 
                              type="primary" 
                              onClick={()=>handleTrackLocation(event)}
                              style={{ backgroundColor: '#1890ff' }}
                            >
                              📍 Track Location
                            </Button>
                          </div>
                          
                        {/* )} */}

                        {/* <div className="mt-2">
                          <label className="text-muted small">ID</label>
                          <p className="mb-0" style={{ fontSize: '11px', fontFamily: 'monospace' }}>{event.id}</p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ):(
              <div className="row">
                <div className="col-12">
                  <div className="card shadow-sm">
                    <div className="card-body">
                      <h5 className="card-title">Location History</h5>
                      <VendorList>
                      <div>
                        <div id="content-wrapper" className="d-flex flex-column">
                          <div className="card shadow mb-4">
                            <div className="card-body pt-0">
                              <div className="table-responsive">
                                <table
                                  className="table table-bordered"
                                  id="dataTable"
                                  width="100%"
                                  cellSpacing="0"
                                >
                                  <thead>
                                    <tr>
                                      <th>Sl. No.</th>
                                      <th>Latitude</th>
                                      <th>Longitude</th>
                                      <th>Date Time</th>
                                      <th>Map Links</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {locationList?.length > 0 ? (
                                      locationList.map((items, index) => (
                                        <>
                                          <tr key={index}>
                                            <td>{SKIP + index + 1}</td>
                                            <td className="admin_user_list_date">
                                              {items?.latitude}                                       
                                            </td>
                                            <td>{items?.longitude}</td>
                                            <td>{items?.date_time}</td>
                                            <td><Link to={`https://www.google.com/maps?q=${items?.latitude},${items?.longitude}`} target="_blank"> <FontAwesomeIcon icon={faMapMarked} /> View</Link></td>

                                          </tr>
                                        </>
                                      ))
                                    ) : isLoading ? <SkeltonList row={5} col={5} /> : <tr> 
                                        <td colspan="9" className="img-center" >No data found !</td> 
                                    </tr>}
                                  </tbody>
                                </table>
                                <div className="table_pagination_sales_order">
                                  <Pagination
                                    count={TOTALPAGES}
                                    onChange={handlePageChange}
                                    page={currentPage}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </VendorList>
                    </div>
                  </div>
                </div>
              </div>
            )}
            


          </div>
        )}
      </Drawer>

      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFilterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFilterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='users_name' selected={filter?.filter_by ==='users_name'?true:false}>First Name</option>
                  <option value='last_name' selected={filter?.filter_by ==='last_name'?true:false}>Last Name</option>
                  <option value='store_name' selected={filter?.filter_by ==='store_name'?true:false}>Store name</option>
                  <option value='users_type' selected={filter?.filter_by ==='users_type'?true:false}>User Type</option>
                  <option value='users_mobile' selected={filter?.filter_by ==='users_mobile'?true:false}>Mobile</option>
                  <option value='pos_number' selected={filter?.filter_by ==='pos_number'?true:false}>POS Number</option>
                  <option value='due_amount' selected={filter?.filter_by ==='due_amount'?true:false}>Due Amount</option>
                  <option value='bind_person_name' selected={filter?.filter_by ==='bind_person_name'?true:false}>Bind with user's name</option>
                  <option value='bind_person_id' selected={filter?.filter_by ==='bind_person_id'?true:false}>Bind with user's id</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
